import { getQueryParam } from '@lib/url';
import { IUser } from '@models/User/i-user';

const getBoardIdFromRouter = (router: NextRouter, user: IUser) => {
  let boardId =
    getQueryParam(router.query, 'board') ||
    getQueryParam(router.query, 'boardId');

  if (router.query.projectBoardCommission) {
    const projectBoardCommission =
      JSON.parse(getQueryParam(router.query, 'projectBoardCommission')!);

    if (projectBoardCommission.userId === Number(user.id)) {
      boardId = projectBoardCommission.boardId;
    }
  }

  return boardId;
};

export default getBoardIdFromRouter;
